import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, ListGroup, ListGroupItem, Glyphicon, Panel, SplitButton, MenuItem, DropdownButton } from 'react-bootstrap';
import _ from 'lodash';
import { withFormik } from 'formik';
import Button from './common/Button';
import Loading from './common/Loading';
import FileUpload from './common/FileUpload';
import Table from './common/Table';
import Cards from './Cards';
import { isEmptyObject } from '../validators/formValidators';
import { caseSetServerError,
         caseFilesLoadAction,
         caseFileAddAction,
         caseFileDeleteAction,
         templatesLoadAction, 
         caseSignGeneratePdfAction,
         templateDeleteAction,
         templatesUploadToCaseFilesAction } from '../actions/caseActions';

import { getOwnerId, 
         getDownloadPath, 
         getLocalDateTimeFromIso,
         replaceFileExtension, 
         getFilledPlaceholers, 
         getObjectValue,
         hasSignaturePlaceholders,
         getSignaturePlaceholders,
         getSignDocumentInfo,
         getWorkflowTranslationHashTable } from '../helpers/utils';

import { userDownloadFile, userEmailTemplatesUpdateAction, userSmsTemplatesUpdateAction } from '../actions/userActions';
import ConfirmDialog from './common/ConfirmDialog';
import { isEmptyString } from '../validators/formValidators';
import SendSmsForm, { isSmsIntegrated } from './common/SendSmsForm';
import SendEmailForm, { isEmailIntegrated } from './common/SendEmailForm';
import SmsDialog from './common/SmsDialog';
import EmailDialog from './common/EmailDialog';
import ManageDocumentTemplates from './common/ManageDocumentTemplates';
import { getPublicSigningUrl, formatBytes, getTextValue } from '../helpers/utils';
import { caseHashDeleteAction } from '../actions/caseActions';
import { getTemplateFinderColor } from '../helpers/colors';
import LoadingProgressBar from './common/LoadingProgressBar';
import DocumentViewer from './common/DocumentViewer';
import CheckBox from './common/CheckBox';

const __fields = ['SignatureLink', 'Signature', 'SignatureDateTime', 'SelectedDocument'];

export const TEMPLATES_CARDS = [
    {label: 'Case Files', value: 'documents', glyph: 'duplicate'},
    {label: 'Doc Templates', value: 'doc_templates', img: '/img/word_icon.png', img_color: '/img/word_icon_brown.png' },
    {label: 'Email Templates', value: 'email_templates', glyph: 'envelope'},
    {label: 'SMS Templates', value: 'sms_templates', glyph: 'phone'}
];

export const EMAIL_SUBTEMPLATES = [
    {label: 'Communication', value: 'notesEmailTemplates', editingEnabled: true},
    {label: 'Sharing', value: 'publicIntakeEmailTemplates', editingEnabled: false},
    {label: 'Documents', value: 'documentSignEmailTemplates', editingEnabled: false},
    {label: 'Paying', value: 'payEmailTemplates', editingEnabled: true},
    {label: 'Receipts', value: 'receiptEmailTemplates', editingEnabled: true},
];

export const SMS_SUBTEMPLATES = [
    {label: 'Communication', value: 'notesSmsTemplates', editingEnabled: true},
    {label: 'Sharing', value: 'publicIntakeSmsTemplates', editingEnabled: false},
    {label: 'Documents', value: 'documentSignSmsTemplates', editingEnabled: false},
    {label: 'Paying', value: 'paySmsTemplates', editingEnabled: true},
    {label: 'Receipts', value: 'receiptSmsTemplates', editingEnabled: true},
];

const ALL_CARDS = {label: 'All', value: undefined};

const TEMPLATES_ACTION_COLUMN = {
    id: 0,
    maxWidth: 30,
    width: 30,
    minWidth: 30,
    sortable: false,
    resizable: false,
    filterable: false,
    accessor: 'icon',
    Cell: (row) => {
        const type = row.original.data['Type'];
        const card = TEMPLATES_CARDS.find(v => v.value === type);
        const color = getTemplateFinderColor(card);
        if (card.glyph) {
            return (<span style={{ backgroundColor: '#FFF' }}><Glyphicon glyph={card.glyph} style={{ fontSize: 20, marginTop: 5, color }} /></span>);
        } else if (card.img_color) {
            return (<img style={{ height: 20, marginTop: 5 }} src={card.img_color} />);
        }

        return '';
    },
};

class TemplatesForm extends PureComponent {
    constructor(props) {
        super(props);
        this.onError = this.onError.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.updateFiles = this.updateFiles.bind(this);
        this.downloadFilledTemplate = this.downloadFilledTemplate.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.selectFile = this.selectFile.bind(this);
        this.selectEmailTemplate = this.selectEmailTemplate.bind(this);
        this.selectSmsTemplate = this.selectSmsTemplate.bind(this);
        this.deleteAll = this.deleteAll.bind(this);
        this.deleteMany = this.deleteMany.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
        this.deleteEmailTemplate = this.deleteEmailTemplate.bind(this);
        this.deleteSmsTemplate = this.deleteSmsTemplate.bind(this);
        this.requestSignature = this.requestSignature.bind(this);
        this.addAsPdf = this.addAsPdf.bind(this);
        this.state = {
            selectedFileRow: undefined,
            placeholdersMap: undefined,
            loadingUploadedFiles: false,
            emailDialogOpen: false,
            faxDialogOpen: false,
            selectedDocumentTemplate: undefined,
            documentsSelector: ALL_CARDS,
            requestingSignatureUrl: false,
            signatureUrl: undefined,
            signatureHash: undefined,
            emailSigningRequestDialogOpen: false,
            smsSigningRequestDialogOpen: false,
            emailSigningRequestLoading: false,
            smsSigningRequestLoading: false,
            templatesFieldName: undefined,
            templateEditingEnabled: true,
            initialTemplate: undefined,
            emailTemplateDialogOpen: false,
            smsTemplateDialogOpen: false,
            deleteTemplateName: undefined,
            deleteTemplateDialogOpen: false,
            deleteTemplateDialogConfirm: undefined,
            addingAsPdf: false,
            previewPlaceholders: true,
        };
    }

    onSubmit(name) {
        this.setState({ loadingUploadedFiles: true });
    }

    onError(name, errorReason) {
        this.setState({ loadingUploadedFiles: false });
        this.props.dispatch(caseSetServerError(errorReason));
    }

    onFinish(name, size) {
        // TODO: if you click upload and immediatelly leave the page? Is the case id going to be screwed up?
        this.props.dispatch(caseFileAddAction('notes', name, this.props.currentCase.id, size));
        this.setState({ loadingUploadedFiles: false });
    }

    deleteFile(rowIndex, row) {
        row = (row && row.data) || row;
        this.setState({ loadingUploadedFiles: true });

        let action;
        const name = row['Name'];
        if (row['Type'] === 'doc_templates') {
            action = templateDeleteAction('document', name);
        } else {
            action = caseFileDeleteAction('notes', name, this.props.currentCase.id);
        }

        this.props.dispatch(action)
            .then((result) => {
                this.setState({ loadingUploadedFiles: false });
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.setState({ loadingUploadedFiles: false });
                this.props.dispatch(caseSetServerError(error));
            });
    }

    async addAsPdf(row) {       
        const templateName = row['Name'];
        const finalName = replaceFileExtension(templateName, 'pdf');
        this.setState({ addingAsPdf: true });
        if (this.props.isDisabled) {
            this.props.isDisabled(true);
        }

        try {
            await this.props.dispatch(templatesUploadToCaseFilesAction('document', templateName, finalName, this.props.currentCase.id));
            await this.props.dispatch(caseFileAddAction('notes', finalName, this.props.currentCase.id));
            this.setState({ addingAsPdf: false });
            if (this.props.isDisabled) {
                this.props.isDisabled(false);
            }

            if (this.props.onChange) {
                this.props.onChange(finalName);
            }

        } catch(error) {
            console.error(new Error().stack, error);
            this.setState({ addingAsPdf: false });
            if (this.props.isDisabled) {
                this.props.isDisabled(false);
            }

            this.props.dispatch(caseSetServerError(error));
        }
    }

    updateFiles(props) {
        if (!props.currentCase.files && !this.state.loadingUploadedFiles && props.currentCase.id && !props.currentCase._loadingFiles) {
            this.setState({loadingUploadedFiles: true});
            props.dispatch(caseFilesLoadAction(props.currentCase.id))
                .then((result) => {
                    if (!result) {
                        props.dispatch(caseSetServerError('Cannot load uploaded files - networking error?'));
                        return;
                    }

                    this.setState({loadingUploadedFiles: false});
                })
                .catch((error) => {
                    props.dispatch(caseSetServerError(error));
                    this.setState({loadingUploadedFiles: false});
                });
        }

        if (!props.templates && !props.loadingTemplates && props.currentCase.id && this.props.currentConfig) {
            this.props.dispatch(templatesLoadAction())
                .then((result) => {
                    if (!result) {
                        this.props.dispatch(caseSetServerError('Cannot load attachments files - networking error?'));
                        return;
                    }

                }).catch((error) => {
                    console.error(new Error().stack, error);
                    props.dispatch(caseSetServerError(error));
                });
        }
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateFiles(nextProps);
        if (nextProps.enabledDocuments) {
            if (nextProps.enabledDocuments.length === 1) {
                this.setState({ documentsSelector: nextProps.enabledDocuments[0] });
            }
        }

        if (nextProps.defaultDocument) {
            this.setState({ documentsSelector: nextProps.defaultDocument });
        }

        const placeholdersMap = getWorkflowTranslationHashTable(nextProps.currentConfig, nextProps.currentCase);
        this.setState({ placeholdersMap });
    }

    selectAll(a, b) {
        const row = (a && a.data && a) || b;
        if (this.props.uploadDocTemplateOnSelect && row.data['Type'] === 'doc_templates') {
            this.addAsPdf(row.data);
            return;
        }

        if (this.props.onChange) {
            this.props.onChange(row.data);
            return;
        }

        switch (row.data['Type']) {
        case 'documents':
            this.selectFile(row.data, userDownloadFile(row.data['$DownloadPath$']));
            break;

        case 'doc_templates':
            this.selectFile(row.data, userDownloadFile(`/api/v1/download/original_template/document/${encodeURIComponent(row.data['Name'])}`));
            break;

        case 'email_templates':
            this.selectEmailTemplate(a, row);
            break;
        case 'sms_templates':
            this.selectSmsTemplate(a, row);
            break;
        }
    }

    selectFile(row, downloadFile) {
        row['$DownloadFunc$'] = downloadFile;
        if (this.props.uploadDocTemplateOnSelect && row['Type'] === 'doc_templates') {
            this.addAsPdf(row);
            return;
        }
        
        if (this.props.onChange) {
            this.props.onChange(row);
            return;
        }

        this.props.setFieldValue('SelectedDocument', row['Name']);
        this.setState({ selectedFileRow: row });        
    }

    selectEmailTemplate(rowIndex, row) {
        row = row.data;
        if (this.props.onChange) {
            this.props.onChange(row);
            return;
        }

        this.setState({ 
            templatesFieldName: row['$TemplatesFieldName$'],
            emailTemplateDialogOpen: true,
            templateEditingEnabled: row['$TemplateEditingEnabled$'],
            initialTemplate: {
                type: row['Name'],
                ...row,
            }
        });
    }

    selectSmsTemplate(rowIndex, row) {
        row = row.data;
        if (this.props.onChange) {
            this.props.onChange(row);
            return;
        }

        this.setState({
            templatesFieldName: row['$TemplatesFieldName$'],
            templateEditingEnabled: row['$TemplateEditingEnabled$'],
            smsTemplateDialogOpen: true,
            initialTemplate: {
                type: row['Name'],
                ...row,
            }
        });
    }

    deleteAll(rowIndex, row) {
        row = (row && row.data) || row;
        switch (row['Type']) {
        case 'documents':
        case 'doc_templates':
            this.setState({
                deleteTemplateDialogOpen: true,
                deleteTemplateName: row['Name'],
                deleteTemplateDialogConfirm: () => {
                    this.deleteFile(rowIndex, row);
                    this.setState({ deleteTemplateDialogOpen: false });
                }
            });            
            break;

        case 'email_templates':
            this.deleteEmailTemplate(rowIndex, row);
            break;
        case 'sms_templates':
            this.deleteSmsTemplate(rowIndex, row);
            break;
        }
    }

    // Bulk delete of the selected rows (the table already asked for confirmation once).
    async deleteMany(rows) {
        const items = rows.map(r => (r && r.data) || r);
        this.setState({ loadingUploadedFiles: true });
        try {
            const emailByField = {};
            const smsByField = {};
            for (const item of items) {
                switch (item['Type']) {
                case 'doc_templates':
                    await this.props.dispatch(templateDeleteAction('document', item['Name']));
                    break;

                case 'email_templates':
                case 'sms_templates': {
                    // The built-in Sharing / Documents templates cannot be removed.
                    if (item['$TemplateEditingEnabled$'] === false) {
                        break;
                    }

                    const byField = item['Type'] === 'email_templates' ? emailByField : smsByField;
                    byField[item['$TemplatesFieldName$']] = byField[item['$TemplatesFieldName$']] || [];
                    byField[item['$TemplatesFieldName$']].push(item['Name']);
                    break;
                }

                default:
                    await this.props.dispatch(caseFileDeleteAction('notes', item['Name'], this.props.currentCase.id));
                    break;
                }
            }

            for (const field of Object.keys(emailByField)) {
                const templates = this.props.currentConfig[field].filter(t => !emailByField[field].includes(t.type));
                await this.props.dispatch(userEmailTemplatesUpdateAction(templates, field));
            }

            for (const field of Object.keys(smsByField)) {
                const templates = this.props.currentConfig[field].filter(t => !smsByField[field].includes(t.type));
                await this.props.dispatch(userSmsTemplatesUpdateAction(templates, field));
            }
        } catch (error) {
            console.error(new Error().stack, error);
            this.props.dispatch(caseSetServerError(error));
        }

        this.setState({ loadingUploadedFiles: false });
    }

    deleteEmailTemplate(rowIndex, row) {
        row = (row && row.data) || row;
        const templates = this.props.currentConfig[row['$TemplatesFieldName$']].filter(template => template.type !== row['Name']);
        this.setState({
            deleteTemplateDialogOpen: true,
            deleteTemplateName: row['Name'],
            deleteTemplateDialogConfirm: () => {
                this.props.dispatch(userEmailTemplatesUpdateAction(templates, row['$TemplatesFieldName$']))
                this.setState({ deleteTemplateDialogOpen: false });
            }
        });
    }

    deleteSmsTemplate(rowIndex, row) {
        row = (row && row.data) || row;
        const templates = this.props.currentConfig[row['$TemplatesFieldName$']].filter(template => template.type !== row['Name']);
        this.setState({
            deleteTemplateDialogOpen: true,
            deleteTemplateName: row['Name'],
            deleteTemplateDialogConfirm: () => {
                this.props.dispatch(userSmsTemplatesUpdateAction(templates, row['$TemplatesFieldName$']));
                this.setState({ deleteTemplateDialogOpen: false });
            }
        });
    }

    downloadFile() {
        if (this.state.selectedFileRow['$Embed$']) {
            let anchor = document.getElementById('downloadFileAnchor');
            if (!anchor) {
                anchor = document.createElement('a');
                anchor.href = this.state.selectedFileRow['$DownloadPath$'];
                anchor.id = 'downloadFileAnchor';
                document.body.appendChild(anchor);
            }

            anchor.click();
        } else {
            this.props.dispatch(this.state.selectedFileRow['$DownloadFunc$']);
        }
    }

    downloadFilledTemplate() {
        let templateName = encodeURIComponent(getTextValue(this.props.values['SelectedDocument']));
        let currentCase = this.props.currentCase;
        let downloadPath = `/api/v1/download/template/document/${templateName}/${currentCase.id}`;
        this.props.dispatch(userDownloadFile(downloadPath));
    }

    requestSignature(stateSuccess, stateFailure) {
        this.setState({requestingSignatureUrl: true});
        const filePlaceholders = this.state.selectedFileRow['$Placeholders$'];
        const caseId = this.props.currentCase && this.props.currentCase.id;
        const name = this.state.selectedFileRow['Name'];
        const placeholders = getFilledPlaceholers(filePlaceholders, this.props.currentCase, this.props.currentConfig);
        const signature_placeholders = getSignaturePlaceholders(filePlaceholders);
        const signees = [];
        for (let i = 0; i < signature_placeholders.length; i++) {
            const placeholder = signature_placeholders[i];
            signees.push({
                placeholder,
                signature: undefined,
                signedDate: undefined,
            });
        }

        this.props.dispatch(caseSignGeneratePdfAction(caseId, name, placeholders, signees))
            .then(result => {
                if (!result || !result.data || !result.data.hash) {
                    this.props.dispatch(caseSetServerError('Document pdf creation failure.'));
                    this.setState({ requestingSignatureUrl: false, ...stateFailure });
                    return;
                }

                const info = getSignDocumentInfo(result.data);
                this.props.dispatch(caseFileAddAction('signed_docs', info.key, this.props.currentCase.id));
                this.setState({
                    requestingSignatureUrl: false,
                    signatureUrl: {
                        'docs.SignatureLink': getPublicSigningUrl(result.data),
                        'docs.DocumentLink': getPublicSigningUrl(result.data)
                    },
                    signatureHash: result.data.hash,
                    ...stateSuccess
                });
            })
            .catch(error => {
                console.error(new Error().stack, error);
                this.setState({ requestingSignatureUrl: false, ...stateFailure });
                this.props.dispatch(caseSetServerError(error));
            });
    }

    render() {
        const {
            submitting,
            loadingCurrent,
            currentCase,
            currentConfig,
            templates = [],
            values,
            loggedIn,
            filterable = undefined,
            enabledDocuments = undefined,
            fileRows = [],
            cardStats = {},
            showDelete = false,
        } = this.props;

        let allRows = [ ...(this.props.allRows || []) ];
        if (this.state.addingAsPdf) {
            return (
                <div>
                <Row style={{ minWidth: '400px' }}>
                <Col xs={12}>
                <h6>Saving PDF from filled Word template ...</h6>
                </Col>
                </Row>
                <Row style={{ minWidth: '400px' }}>
                <Col xs={12}>
                    <LoadingProgressBar loading={true} />
                </Col>
                </Row>
                </div>
            );
        }

        let loadingFiles = typeof(currentCase.files) == 'undefined' && currentCase.id;
        const all_headers = [
            {
                table: 'data',
                name: 'Name',
                id: 'Name',
                label: 'Name',
                filterable,
                accessor: c => c['data']['$Label$'] || c['data']['Name'],
                width: '*'
            }
        ];

        const files_headers = [
            {
                table: 'data',
                name: 'Name',
                id: 'Name',
                filterable,
                label: 'Name',
                width: '*'
            },
        ];

        const email_headers = [
            {
                table: 'data',
                name: 'Name',
                id: 'Name',
                filterable,
                accessor: c => c['data']['$Label$'] || c['data']['Name'],
                label: 'Name',
                width: '*'
            },
        ];

        const sms_headers = [
            {
                table: 'data',
                name: 'Name',
                id: 'Name',
                filterable,
                accessor: c => c['data']['$Label$'] || c['data']['Name'],
                label: 'Name',
                width: '*'
            }
        ];

        if (!__IS_MOBILE__) {
            files_headers.push({
                table: 'data',
                name: '$LastModified$',
                filterable,
                label: 'Last Modified',
                width: 120,
            });

            email_headers.push({
                table: 'data',
                name: 'Subject',
                filterable,
                label: 'Subject',
                width: 100,
            });

            email_headers.push({
                table: 'data',
                name: 'Message',
                filterable,
                label: 'Message',
                width: 100,
            });

            sms_headers.push({
                table: 'data',
                name: 'Message',
                filterable,
                label: 'Message',
                width: 150,
            });
        }

        let emailSubtemplateRows = [];
        let smsSubtemplateRows = [];
        if (enabledDocuments) {
            allRows = allRows.filter(v => enabledDocuments.map(v => v.value).includes(v.data['Type']));
        } 
        
        if (this.state.documentsSelector.value === 'sms_templates') {
            smsSubtemplateRows = allRows.filter(v => v.data['Type'] === 'sms_templates');
        } else if (this.state.documentsSelector.value === 'email_templates') {
            emailSubtemplateRows = allRows.filter(v => v.data['Type'] === 'email_templates');
        }

        const editEmailTemplates = (currentConfig && currentConfig["documentSignEmailTemplates"]) || [];
        const editSmsTemplates = (currentConfig && currentConfig["documentSignSmsTemplates"]) || [];
        let shareText = 'Document View Link';
        if (hasSignaturePlaceholders(getObjectValue(this.state.selectedFileRow, '$Placeholders$'))) {
            shareText = 'Request for Signature';
        }

        const fileActionPanel = (
            <Row>
            <Col xs={12}>
            <ListGroup>
            <ListGroupItem style={{ border: '0px none', textOverflow: 'ellipsis', overflow: 'hidden' }} header={(<h6>Document Template Name</h6>)}>{this.props.values['SelectedDocument']}</ListGroupItem>
            <ListGroupItem style={{ border: '0px none', textOverflow: 'ellipsis', overflow: 'hidden' }} header={(<h6>Last Modified</h6>)}>{this.state.selectedFileRow && this.state.selectedFileRow['$LastModified$']}</ListGroupItem>
            {this.state.selectedFileRow && this.state.selectedFileRow['Type'] == 'doc_templates' && (
            <ListGroupItem style={{ border: '0px none', textOverflow: 'ellipsis', overflow: 'hidden' }} header={(<h6>Show Filled</h6>)}>
            <CheckBox
                field={{
                    name: 'previewPlaceholders'
                }}
                checked={this.state.previewPlaceholders}
                help="If checked, values that will replace placeholders will be overlayed on top of document."
                onChange={elem => {
                    this.setState({previewPlaceholders: !this.state.previewPlaceholders});
                }}
            />
            </ListGroupItem>)}
            </ListGroup>
            </Col>
            {(this.state.selectedFileRow && this.state.selectedFileRow['Type'] == 'doc_templates') ? (
                <div>
                <Row>
                <Col xs={12}>
                <SplitButton title={(<span><Glyphicon glyph="download"/> Download</span>)}
                             data-hj-whitelist 
                             bsStyle="default"
                             style={{ marginLeft: 25, width: 120 }}
                             onClick={this.downloadFile}
                             disabled={submitting || loadingCurrent || this.state.requestingSignatureUrl}
                >
                <MenuItem data-hj-whitelist
                          onClick={this.downloadFilledTemplate}
                          disabled={submitting || loadingCurrent || this.state.requestingSignatureUrl || isEmptyObject(this.props.currentCase)}
                ><Glyphicon glyph="download"/> Filled</MenuItem>
                </SplitButton>
                </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                <Col xs={12}>
                <DropdownButton title={(<span>{this.state.requestingSignatureUrl ? <Loading inline delay={false}/> : <Glyphicon glyph="share"/>} Share</span>)}
                                data-hj-whitelist 
                                bsStyle="default"
                                style={{ marginLeft: 25, width: 120 }}
                                disabled={submitting || loadingCurrent || this.state.requestingSignatureUrl}
                >
                <MenuItem data-hj-whitelist
                          disabled={!isEmailIntegrated(loggedIn) || this.state.requestingSignatureUrl || loadingCurrent || submitting || this.state.emailSigningRequestDialogOpen ||
                          isEmptyString(values['SelectedDocument']) || isEmptyObject(this.props.currentCase)}
                          onClick={() => { 
                            this.setState({ emailSigningRequestLoading: true });
                            this.requestSignature({ emailSigningRequestDialogOpen: true, emailSigningRequestLoading: false, selectedFileRow: undefined },
                                                    { emailSigningRequestDialogOpen: false, emailSigningRequestLoading: false });
                          }}
                ><Glyphicon glyph="envelope"/> Email {shareText}</MenuItem>
                <MenuItem data-hj-whitelist
                          onClick={() => { 
                              this.setState({ smsSigningRequestLoading: true });
                              this.requestSignature({ smsSigningRequestDialogOpen: true, smsSigningRequestLoading: false, selectedFileRow: undefined },
                                                      { smsSigningRequestDialogOpen: false, smsSigningRequestLoading: false });
                          }}
                          disabled={!isSmsIntegrated(loggedIn) || this.state.requestingSignatureUrl || loadingCurrent || submitting || this.state.smsSigningRequestDialogOpen ||
                                  isEmptyString(values['SelectedDocument']) || isEmptyObject(this.props.currentCase)}
                ><Glyphicon glyph="phone"/> SMS {shareText}</MenuItem>
                </DropdownButton>
                </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                <Col xs={12} md={6}>
                <Button label='Delete'
                        icon='trash'
                        style={{ width: 120, marginLeft: 25 }}
                        onClick={evt => {
                            evt.preventDefault();
                            this.deleteFile(-1, { data: this.state.selectedFileRow });
                            this.setState({ selectedFileRow: undefined });
                        }}
                        disabled={submitting || loadingCurrent || this.state.requestingSignatureUrl}
                />
                </Col>
                </Row>
                </div>
            ) : (
                <div>
                <Row>
                <Col xs={12}>    
                <Button label='Download'
                        icon='download'
                        style={{ marginLeft: 25, width: 120 }}
                        onClick={this.downloadFile}
                        disabled={submitting || loadingCurrent || this.state.requestingSignatureUrl}
                />
                </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                <Col xs={12} md={6}>
                <Button label='Delete'
                        icon='trash'
                        style={{ width: 120, marginLeft: 25 }}
                        onClick={evt => {
                            evt.preventDefault();
                            this.deleteFile(-1, { data: this.state.selectedFileRow });
                            this.setState({ selectedFileRow: undefined });
                        }}
                        disabled={submitting || loadingCurrent || this.state.requestingSignatureUrl || (this.state.selectedFileRow && this.state.selectedFileRow['$Subfolder$'] !== 'notes')}
                />
                </Col>
                </Row>
                </div>
            )}
            </Row>);

        return (
            <div>
            <Row style={{ marginTop: 8 }}>
            <Col xs={12}>
                <Cards 
                    onClick={value => {
                        if ((!enabledDocuments || enabledDocuments.length != 1) && _.isEqual(this.state.documentsSelector, value)) {
                            this.setState({ documentsSelector: ALL_CARDS });
                        } else {
                            this.setState({ documentsSelector: value }) 
                        }
                    } }
                    selectedCard={this.state.documentsSelector}
                    cards={TEMPLATES_CARDS}
                    enabledCards={enabledDocuments}
                    cardStats={cardStats}
                    cardColor={getTemplateFinderColor}
                    cardSizes={{
                        xs: 6,
                        md: 3,
                        lg: 3
                    }}
                />
            </Col>
            </Row>
            {this.state.documentsSelector.value === undefined && (
            <div>
            {(this.state.loadingUploadedFiles || loadingFiles) && (
            <Row>
            <LoadingProgressBar loading={this.state.loadingUploadedFiles || loadingFiles} />
            </Row>)}
            <Row>
            <Col xs={12} style={{backgroundColor: '#FFF', minHeight: 230}}>
            <Table headers={all_headers}
                   rows={allRows}
                   downloadRow={this.selectAll}
                   downloadBsStyle="link"
                   deleteRow={showDelete && this.deleteAll}
                   deleteRows={showDelete && this.deleteMany}
                   deleteBsStyle="link"
                   filterable={allRows.length > 5}
                   defaultPageSize={allRows.length > 5 ? 5 : 0}
                   customActionColumn={TEMPLATES_ACTION_COLUMN}
                   getRef={tableRef => {
                        this.allTableRef = tableRef;
                   }}
            />
            </Col>
            </Row>
            </div>)}
            {this.state.documentsSelector.value === 'email_templates' && (
                <Row>
                <Col xs={12} style={{backgroundColor: '#FFF', minHeight: 230}}>
                <Table headers={email_headers}
                       rows={emailSubtemplateRows}
                       downloadRow={this.selectEmailTemplate}
                       downloadBsStyle="link"
                       deleteRow={showDelete && this.deleteEmailTemplate}
                       deleteRows={showDelete && this.deleteMany}
                       deleteBsStyle="link"
                       filterable={emailSubtemplateRows.length > 5}
                       defaultPageSize={emailSubtemplateRows.length > 5 ? 5 : 0}
                       customActionColumn={TEMPLATES_ACTION_COLUMN}
                       getRef={tableRef => {
                           this.emailTableRef = tableRef;
                       }}
                />
                </Col>
                </Row>
            )}
            {this.state.documentsSelector.value === 'sms_templates' && (
                <Row>
                <Col xs={12} style={{backgroundColor: '#FFF', minHeight: 230}}>
                <Table headers={sms_headers}
                       rows={smsSubtemplateRows}
                       downloadRow={this.selectSmsTemplate}
                       downloadBsStyle="link"
                       deleteRow={showDelete && this.deleteSmsTemplate}
                       deleteRows={showDelete && this.deleteMany}
                       deleteBsStyle="link"
                       filterable={smsSubtemplateRows.length > 5}
                       defaultPageSize={smsSubtemplateRows.length > 5 ? 5 : 0}
                       customActionColumn={TEMPLATES_ACTION_COLUMN}
                       getRef={tableRef => {
                           this.smsTableRef = tableRef;
                       }}
                />
                </Col>
                </Row>
            )}
            {this.state.documentsSelector.value === 'documents' && (
            <div>
                <Row>
                <Col xs={12} style={{backgroundColor: '#FFF'}}>
                    <FileUpload
                        loading={this.state.loadingUploadedFiles || loadingFiles}
                        headers={files_headers}
                        rows={fileRows}
                        customFieldsMap={
                            {
                                'data.$Size$': {
                                    type: 'DiskSize'
                                },
                                'data.$LastModified$': {
                                    type: 'DateTimeInput'
                                },
                            }
                        }
                        folder={`${getOwnerId(this.props.loggedIn)}/case/${currentCase.id}/notes`}
                        extensions={['*']}
                        sizeLimit={parseInt(process.env.AWS_TEMPLATE_SIZE_LIMIT)}
                        onError={this.onError}
                        onFinish={this.onFinish}
                        onSubmit={this.onSubmit}
                        onDelete={showDelete && this.deleteFile}
                        onDeleteMany={showDelete && this.deleteMany}
                        downloadRow={this.selectFile}
                        renderFiles={true}
                        renderUpload={true}
                        customActionColumn={TEMPLATES_ACTION_COLUMN}
                        getRef={tableRef => {
                            this.documentsTableRef = tableRef;
                        }}
                    />
                </Col>
                </Row>
            </div>)}
            {this.state.documentsSelector.value === 'doc_templates' && (
            <Row>
            <Col xs={12} style={{backgroundColor: '#FFF', minHeight: 230}}>
                <ManageDocumentTemplates
                    downloadRow={this.selectFile}
                    showDelete={showDelete}
                    customActionColumn={TEMPLATES_ACTION_COLUMN}
                    filterable={filterable}
                    templates={templates}
                    getRef={tableRef => {
                        this.docTemplatesTableRef = tableRef;
                    }}
                />
            </Col>
            </Row>)}

            <ConfirmDialog title={this.state.selectedFileRow && this.state.selectedFileRow['Type'] == 'doc_templates' ? 'Document Template Viewer' : 'Document Viewer'}
                           cancel={() => this.setState({ selectedFileRow: undefined })}
                           open={this.state.selectedFileRow}
                           size='welcome'
            >
            <Row>
            <Col xs={12} md={3} style={{ marginBottom: 35 }}>
            {fileActionPanel}
            </Col>
            <Col xs={12} md={9} >
            <Panel header='Preview'>
            <DocumentViewer file={this.state.selectedFileRow}
                            caseId={this.props.currentCase && this.props.currentCase.id}
                            fitHeightToWindow={false}
                            placeholdersMap={this.state.placeholdersMap}
                            previewPlaceholders={this.state.previewPlaceholders}
            />
            </Panel>
            </Col>
            </Row>
            </ConfirmDialog>
            <EmailDialog title="Email Template"
                         templateEditor={false}
                         templatesFieldName={this.state.templatesFieldName}
                         enableAddTemplate={this.state.templateEditingEnabled}
                         enableEditTemplate={this.state.templateEditingEnabled}
                         initialTemplate={this.state.initialTemplate}
                         cancel={() => this.setState({ emailTemplateDialogOpen: false })}
                         open={this.state.emailTemplateDialogOpen}
            />
            <SmsDialog title="SMS Template"
                       templateEditor={false}
                       templatesFieldName={this.state.templatesFieldName}
                       enableAddTemplate={this.state.templateEditingEnabled}
                       enableEditTemplate={this.state.templateEditingEnabled}
                       initialTemplate={this.state.initialTemplate}
                       cancel={() => this.setState({ smsTemplateDialogOpen: false })}
                       open={this.state.smsTemplateDialogOpen}
            />
            <SendEmailForm showAsDialog
                        initialTemplate={editEmailTemplates && {...editEmailTemplates[0]}}
                        templatesFieldName="documentSignEmailTemplates"
                        enableAddTemplate={false}
                        enableEditTemplate={false}
                        renderTemplateLoad={false}
                        renderEmailSection
                        renderEmailButton
                        disableCaseFilesAutoload
                        renderAttachmentField={false}
                        onEmailSent={() => this.setState({ emailSigningRequestDialogOpen: false })}
                        cancel={async () => {
                            if (this.state.signatureHash) {
                                await this.props.dispatch(caseHashDeleteAction(this.state.signatureHash));
                                await this.props.dispatch(caseFileDeleteAction('signed_docs', this.props.values['SelectedDocument'], currentCase.id))
                            }

                            this.setState({ emailSigningRequestDialogOpen: false, signatureHash: undefined });
                        }}
                        open={this.state.emailSigningRequestDialogOpen}
                        title="Email Request for Signature"
                        extraPlaceholders={this.state.signatureUrl}
            />
            <SendSmsForm showAsDialog
                        templates={editSmsTemplates}
                        initialTemplate={editSmsTemplates && {...editSmsTemplates[0]}}
                        templatesFieldName="documentSignSmsTemplates"
                        enableAddTemplate={false}
                        enableEditTemplate={false}
                        renderTemplateLoad={false}
                        onSmsSent={() => this.setState({ smsSigningRequestDialogOpen: false })}
                        cancel={async () => {
                            if (this.state.signatureHash) {
                                await this.props.dispatch(caseHashDeleteAction(this.state.signatureHash));
                                await this.props.dispatch(caseFileDeleteAction('signed_docs', this.props.values['SelectedDocument'], currentCase.id))
                            }

                            this.setState({ smsSigningRequestDialogOpen: false, signatureHash: undefined });
                        }}
                        open={this.state.smsSigningRequestDialogOpen}
                        title="SMS Request for Signature"
                        extraPlaceholders={this.state.signatureUrl}
            />
            <ConfirmDialog
                    title='Delete?'
                    text={`Do you really want to delete '${this.state.deleteTemplateName}'?`}
                    warning
                    cancel={() => {this.setState({ deleteTemplateDialogOpen: false })}}
                    confirm={this.state.deleteTemplateDialogConfirm}
                    open={this.state.deleteTemplateDialogOpen} />
            </div>);
    }
}

TemplatesForm.propTypes = {
    showAsDialog: PropTypes.bool,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    serverError: PropTypes.string,
    resetForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    loadingCurrent: PropTypes.bool.isRequired,
    caseFilesAutoload: PropTypes.bool,
    onTemplateUploaded: PropTypes.func,
    filterable: PropTypes.bool,
    onSelect: PropTypes.func,
    enabledDocuments: PropTypes.array,
    defaultSubdocument: PropTypes.object,
    defaultDocument: PropTypes.object,
    filterNameValue: PropTypes.string,
    uploadDocTemplateOnSelect: PropTypes.bool,
    isDisabled: PropTypes.func,
    showDelete: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    let currentCase = state.cases.current;
    let caseType;
    if (currentCase && currentCase.intake) {
        caseType = currentCase.intake['CaseType'];
    }

    const loggedIn = state.user.loggedIn;
    let initialValues = {...state.cases.current.docs};
    let currentConfig = state.user.config;
    let files = [];
    if (currentCase && currentCase.files) {
        files = currentCase.files;
    }

    const cardStats = {};
    let fileRows = [];
    if (!isEmptyObject(files) && Object.keys(files)) {
        Object.keys(files).forEach(subfolder => {
            if (!files[subfolder]) {
                return;
            }
            files[subfolder].forEach(v => {
                const row = {};
                row.data = {};
                row.data['Type'] = 'documents';
                row.data['Name'] = v.fileName;
                row.data['$LastModified$'] = getLocalDateTimeFromIso(loggedIn, v.LastModified);
                row.data['$Size$'] = formatBytes(v.Size);
                row.data['$Placeholders$'] = v.placeholders;
                row.data['$Subfolder$'] = subfolder;
                row.data['$DownloadPath$'] = getDownloadPath(currentCase.id, v.fileName, subfolder);
                row.data['$Embed$'] = v['Embed'];
                row.data['$StorageType$'] = v['StorageType'] || 'S3';
                cardStats['documents'] = (cardStats['documents'] || 0) + 1;
                fileRows.push(row);
            });
        });
    }

    let allRows = [];
    const templates = state.cases.templates;
    if (!isEmptyObject(currentConfig)) {
        cardStats['email_templates'] = 0;
        cardStats['sms_templates'] = 0;

        if (!isEmptyObject(templates)) {
            templates['document'] && templates['document'].forEach(v => {
                const row = {};
                const templateName = encodeURIComponent(v.fileName);
                row.data = {};
                row.data['Type'] = 'doc_templates';
                row.data['$IsTemplate$'] = true;
                row.data['Name'] = v.fileName;
                row.data['$LastModified$'] = getLocalDateTimeFromIso(loggedIn, v.LastModified);
                row.data['$Size$'] = formatBytes(v.Size);
                row.data['$Placeholders$'] = v.placeholders;
                row.data['$DownloadPath$'] = `/api/v1/download/template/document/${templateName}/${currentCase.id}`;
                row.data['$Subfolder$'] = 'template/document';
                cardStats['doc_templates'] = (cardStats['doc_templates'] || 0) + 1;
                allRows.push(row);
            });
        }

        allRows.push(...fileRows);
        EMAIL_SUBTEMPLATES.forEach(c => currentConfig[c['value']].forEach(v => {
            if (ownProps.defaultSubdocument && c['value'] !== ownProps.defaultSubdocument) {
                return;
            }

            allRows.push({
                data: {
                    Name: v['type'],
                    '$Label$': `${v['type']} (${c['label']})`,
                    Type: 'email_templates',
                    Subject: v['Subject'],
                    Message: v['Message'],
                    '$TemplatesFieldName$': c['value'],
                    '$TemplateEditingEnabled$': c['editingEnabled']
                }
            });

            cardStats['email_templates'] += 1;
        }));

        SMS_SUBTEMPLATES.forEach(c => currentConfig[c['value']].forEach(v => {
            if (ownProps.defaultSubdocument && c['value'] !== ownProps.defaultSubdocument) {
                return;
            }

            allRows.push({
            data: {
                Name: v['type'],
                '$Label$': `${v['type']} (${c['label']})`,
                Type: 'sms_templates',
                Message: v['Message'],
                '$TemplatesFieldName$': c['value'],
                '$TemplateEditingEnabled$': c['editingEnabled']
            }});

            cardStats['sms_templates'] += 1;
        }));

        // allRows.sort((a, b) => {
        //     a = a.data['$Label$'] || a.data['Name'];
        //     b = b.data['$Label$'] || b.data['Name'];
        //     if (a < b) {
        //         return -1;
        //     }

        //     if (a > b) {
        //         return 1;
        //     }

        //     return 0;
        // });
    }
        
    return {
        loggedIn,
        allRows,
        fileRows,
        cardStats,
        currentCase,
        currentConfig,
        caseType,
        initialValues,
        loadingCurrent: state.cases.loadingCurrent,
        templates,
        loadingTemplates: state.cases._loadingDocumentTemplates,
    }
};

const formikWrapper = {
    mapPropsToValues: props => props.initialValues,
    enableReinitialize: true,
};

export default connect(mapStateToProps)(withFormik(formikWrapper)(TemplatesForm));
